import type { BrowserTracker } from '@snowplow/browser-tracker';
import { newTracker, trackPageView, trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import getConfig from 'next/config';

import { isProd } from 'Utilities/helpers';

import { SNOWPLOW_SCHEMA_BASE_URL } from '../analytics/analytics.const';

import { PAGE_VIEW_EVENT_EXCLUDED_PATHS } from './snowplow.const';

const { publicRuntimeConfig } = getConfig();

export const initSnowplowTracker = ({
	isSnowplowMiniRedirect,
}: {
	isSnowplowMiniRedirect: boolean;
}): BrowserTracker => {
	const { SNOWPLOW_COLLECTOR_URL, SNOWPLOW_MINI_URL } = publicRuntimeConfig;

	const COLLECTOR_URL = isSnowplowMiniRedirect ? SNOWPLOW_MINI_URL : SNOWPLOW_COLLECTOR_URL;

	return newTracker('sp1', COLLECTOR_URL, {
		appId: `dealer-website-${isProd ? 'prod' : 'test'}`,
		cookieDomain: 'pro.motorway.co.uk',
		cookieSameSite: 'Lax',
		discoverRootDomain: false,
		onSessionUpdateCallback() {
			setTimeout(() => {
				trackSelfDescribingEvent({
					event: {
						data: {},
						schema: `${SNOWPLOW_SCHEMA_BASE_URL}/new_session_start/jsonschema/1-0-0`,
					},
				});
			}, 0);
		},
		plugins: [],
	});
};

export const trackSnowplowPageView = (): void => {
	const { pathname, search } = window.location;
	const windowUrl = `${pathname}${search}`;

	if (PAGE_VIEW_EVENT_EXCLUDED_PATHS.includes(windowUrl)) {
		return;
	}

	trackPageView();
};
